import cx from "classnames"
import { useSelector } from "react-redux"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { Props as DrawerProps } from "src/shared/components/layout/drawer/Drawer.types"
import { RootState } from "src/store/store"
import { useRoomDarwer } from "../hooks/darwer"
import DrawerSkeleton from "./DrawerSkeleton/DrawerSkeleton"
import "./DrawerWrapper.css"

type Props = Omit<DrawerProps, "visible" | "onClose">

function DrawerWrapper({ className = "", children, withMenu, withBackButton, ...rest }: Props): JSX.Element {
    const { visible, onClose } = useRoomDarwer()
    const isLoadingSelectedRoom = useSelector((state: RootState) => state.rooms.isLoadingSelectedRoom)

    return (
        <Drawer
            placement={"right"}
            bar={false}
            visible={visible}
            withCloseButton={true}
            onClose={onClose}
            className={cx("drawer-wrapper", className)}
            withMenu={withMenu && !isLoadingSelectedRoom}
            withBackButton={withBackButton && !isLoadingSelectedRoom}
            {...rest}
        >
            {isLoadingSelectedRoom && <DrawerSkeleton />}
            {/* El contenido se oculta en lugar de desmontarse para conservar su estado y los modales abiertos */}
            <div
                className={cx("drawer-wrapper__content", {
                    "drawer-wrapper__content--hidden": isLoadingSelectedRoom,
                })}
            >
                {children}
            </div>
        </Drawer>
    )
}

export default DrawerWrapper
